<div class="row-detail-view">
  <div *ngIf="isLoading; else finished">
    <div>
      <p>
        Loading ... {{DocID}}
      </p>
    </div>
  </div>
  <ng-template #finished>
    <div>
      <dx-tab-panel #tabPanel
                    [height]="150"
                    [dataSource]="getTabs()"
                    [selectedIndex]="0"
                    [loop]="false"
                    [animationEnabled]="true"
                    [swipeEnabled]="true">

        <div *dxTemplate="let row of 'title'">
          <span>{{row.title}}</span>
        </div>
        <div *dxTemplate="let row of 'item'">
          <div class="tabpanel-item">
            <div [ngSwitch]="row.type">
              <!--<div *ngSwitchCase="'Info'">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="fl">
                        <div>
                          <label class="lbl-text">Grantors:</label>
                          <dx-list itemsize="20">
                            <dxi-item *ngFor="let dtor of row.payload.info.docTors; let i = index" class="item-parties">
                              <div *ngIf="i<3">
                                <div *ngIf="dtor.fName !== ''; else lastnameonlytor">
                                  {{dtor.lastCorpName}}, {{dtor.fName}}
                                </div>
                                <ng-template #lastnameonlytor>
                                  {{dtor.lastCorpName}}
                                </ng-template>
                              </div>
                            </dxi-item>
                          </dx-list>
                        </div>
                        <div>
                          <label class="lbl-text">Grantees:</label>
                          <dx-list itemsize="20" class="m-t">
                            <dxi-item *ngFor="let dtee of row.payload.info.docTees; let i = index" class="item-parties">
                              <div *ngIf="dtee.fName !== ''; else lastnameonlytee">
                                {{dtee.lastCorpName}}, {{dtee.fName}}
                              </div>
                              <ng-template #lastnameonlytee>
                                {{dtee.lastCorpName}}
                              </ng-template>
                            </dxi-item>
                          </dx-list>
                        </div>
                      </div>
                      <div class="fl m-l">
                        <div>
                          <label class="lbl-text">Doc Date:</label>
                          <Label>{{row.payload.info.recordDate }}</Label>
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>-->
                <div *ngSwitchCase="'Parties'">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-sm-6">
                        <label>Grantors:</label>
                        <dx-list itemSize="20" class="parties-viewport" (onItemClick)="ItemClick('$event')" [useNativeScrolling]="false" showScrollBar="always">
                          <dxi-item *ngFor="let dtor of row.payload.grantors" class="item-parties">
                            <div *ngIf="dtor.fName !== ''; else lastnameonlytor">
                              {{dtor.lastCorpName}}, {{dtor.fName}}
                            </div>
                            <ng-template #lastnameonlytor>
                              {{dtor.lastCorpName}}
                            </ng-template>
                          </dxi-item>
                        </dx-list>
                      </div>
                      <div class="col-sm-6">
                        <label>Grantees:</label>
                        <dx-list itemSize="20" class="parties-viewport" (onItemClick)="ItemClick('$event')" [useNativeScrolling]="false" showScrollBar="always">
                          <dxi-item *ngFor="let dtee of row.payload.grantees" class="item-parties">
                            <div *ngIf="dtee.fName !== ''; else lastnameonlytee">
                              {{dtee.lastCorpName}}, {{dtee.fName}}
                            </div>
                            <ng-template #lastnameonlytee>
                              {{dtee.lastCorpName}}
                            </ng-template>
                          </dxi-item>
                        </dx-list>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngSwitchCase="'Referrals'">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-sm-4">
                        <label>Refers To:</label>
                        <dx-list itemSize="20" class="parties-viewport" (onItemClick)="ItemClick('$event')" [useNativeScrolling]="false" showScrollBar="always">
                          <dxi-item *ngFor="let drefto of row.payload.refto" class="item-parties">
                            {{drefto.docType}}:{{drefto.primaryID}}/{{drefto.secondaryID}}
                          </dxi-item>
                        </dx-list>
                      </div>
                      <div class="col-sm-4">
                        <label>Referred To By:</label>
                        <dx-list itemSize="20" class="parties-viewport" (onItemClick)="ItemClick('$event')" [useNativeScrolling]="false" showScrollBar="always">
                          <dxi-item *ngFor="let drefby of row.payload.refby" class="item-parties">
                            {{drefby.docType}}:{{drefby.primaryID}}/{{drefby.secondaryID}}
                          </dxi-item>
                        </dx-list>
                      </div>
                      <div class="col-sm-4">
                        <label>Transaction Documents:</label>
                        <dx-list itemSize="20" class="parties-viewport" (onItemClick)="ItemClick('$event')" [useNativeScrolling]="false" showScrollBar="always">
                          <dxi-item *ngFor="let dtran of row.payload.trans" class="item-parties">
                            {{dtran.docType}}:{{dtran.primaryID}}/{{dtran.secondaryID}}
                          </dxi-item>
                        </dx-list>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngSwitchCase="'Address'">
                  <dx-list itemSize="20">
                    <dxi-item *ngFor="let dAddress of row.payload" class="item-parties">
                      <p>
                        <label>Address:</label> {{dAddress.address}}
                      </p>
                    </dxi-item>
                  </dx-list>
                </div>
              </div>
            </div>

        </div>

      </dx-tab-panel>
    </div>
  </ng-template>
</div>
